import { AddressBookFeatures } from "../interfaces/address-book-features";

export const ADDRESS_BOOK_INITIAL_VALUES: AddressBookFeatures = {
    companyNameLabel: 'Company Name/Address Line 1',
    streetAddressLabel: 'Street Address',
    suiteUnitLabel: 'Suite/Unit',
    suiteRequired: false,
    cityLabel: 'City',
    cityRequired: false,
    stateProvinceLabel: 'State/Province/Region',
    stateRequired: false,
    countryLabel: 'Country',
    phoneNumberLabel: 'Phone Number',
    phoneNumberRequired: false,
    zipPostalCodeLabel: 'Zip/Postal Code',
    showDeliveryInstructions: false,
    deliveryInstructionsLabel: '',
    deliveryInstructionsRequired: false,
    showMainContactEmail: false,
    mainContactEmailLabel: '',
    mainContactEmailRequired: false,
    showMainContactName: false,
    mainContactNameLabel: '',
    mainContactNameRequired: false,
    showAdditionalContactName: false,
    additionalContactNameLabel: '',
    additionalContactNameRequired: false,
    showAdditionalContactEmail: false,
    additionalContactEmailLabel: '',
    additionalContactEmailRequired: false,
    showClientAddressId: false,
    clientAddressIdLabel: '',
    clientAddressIdRequired: false,
}